import { render, staticRenderFns } from "./OrderHistoryContent.vue?vue&type=template&id=6f35f38d&scoped=true&"
import script from "./OrderHistoryContent.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryContent.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryContent.vue?vue&type=style&index=0&id=6f35f38d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f35f38d",
  null
  
)

export default component.exports